module.exports = "/img/4.3fa3e9.webp";